import EcoImg from 'eco-design/base/eco-img';
import { useRef, useState, useEffect } from 'react';
import { Navigation, EffectFade, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './index.module.scss';
import { useStoriesConfig, StoryItem } from './config';
import PlusIcon from './PlusIcon';
import CardModal from './CardModal';
import More from './More';

export default function Stories() {
    const { groupList, t } = useStoriesConfig();
    const swiperRef = useRef<any>(null);

    const [visible, setVisible] = useState(false);
    const [moreVisible, setMoreVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState<any>({});
    const [activeIndex, setActiveIndex] = useState(0);
    const [animationKey, setAnimationKey] = useState(0);
    const [isPc, setIsPc] = useState(true);

    useEffect(() => {
        const checkDevice = () => {
            setIsPc(window.innerWidth > 768);
        };
        checkDevice();
        window.addEventListener('resize', checkDevice);
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    const clickCard = (card: StoryItem) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    const currentGroup = groupList[activeIndex];

    return (
        <div className={`${styles.Stories} GtmModuleData-section`}>
            <div className="pfa-layout">
                {/* Header Section with Navigation */}
                <div className="header">
                    <button className="nav-arrow nav-prev" onClick={() => swiperRef.current?.slidePrev()} aria-label="Previous">
                        <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11 1L1 11L11 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>

                    <div className="header-content" key={`header-${activeIndex}`}>
                        <h2 className="title">{currentGroup.title}</h2>
                        <p className="desc">{currentGroup.desc}</p>
                    </div>

                    <button className="nav-arrow nav-next" onClick={() => swiperRef.current?.slideNext()} aria-label="Next">
                        <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L11 11L1 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                {/* Swiper for Cards */}
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onSlideChange={(swiper) => {
                        setActiveIndex(swiper.realIndex);
                        setAnimationKey((prev) => prev + 1);
                    }}
                    spaceBetween={26}
                    slidesPerView={1}
                    loop={true}
                    modules={[Navigation, EffectFade, Pagination]}
                    effect={'fade'}
                    allowTouchMove={!isPc}
                    className="stories-swiper"
                    pagination={{ clickable: true }}
                >
                    {groupList.map((group, groupIndex) => (
                        <SwiperSlide key={group.id}>
                            <div className="card-group">
                                {group.stories.map((item, index) => (
                                    <div
                                        className={`card ${groupIndex === activeIndex ? 'card-animate' : ''}`}
                                        key={index}
                                        onClick={() => clickCard(item)}
                                        style={
                                            {
                                                '--card-delay': `${index * 0.2}s`,
                                            } as React.CSSProperties
                                        }
                                        data-animation-key={animationKey}
                                    >
                                        <div className="card-img">
                                            <EcoImg pc={item.img} h5={item.img} />
                                        </div>
                                        <div className="card-content" key={`content-${activeIndex}-${index}`}>
                                            <h3 className="card-title">{item.title}</h3>
                                            <p className="card-desc">{item.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Learn More Stories Button */}
                <div className="btn-wrapper">
                    <button className="btn-more-stories" onClick={() => setMoreVisible(true)}>
                        <span>{t('secCommon_more')}</span>
                        <PlusIcon />
                    </button>
                </div>
            </div>

            {/* Card Modal */}
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}

            {/* More Modal */}
            {moreVisible && <More arr={currentGroup.moreList} onClose={() => setMoreVisible(false)} />}
        </div>
    );
}
